import { render, staticRenderFns } from "./UgcWithReviews.vue?vue&type=template&id=b7b35974&lang=pug"
import script from "./UgcWithReviews.vue?vue&type=script&lang=js"
export * from "./UgcWithReviews.vue?vue&type=script&lang=js"
import style0 from "./UgcWithReviews.vue?vue&type=style&index=0&id=b7b35974&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports